import CaptainPromptVersions from 'dashboard/api/captain/promptVersions';
import { createStore } from '../storeFactory';
import { throwErrorMessage } from 'dashboard/store/utils/api';

export default createStore({
  name: 'CaptainPromptVersion',
  API: CaptainPromptVersions,
  actions: mutations => ({
    get: async ({ commit }, { assistantId }) => {
      commit(mutations.SET_UI_FLAG, { fetchingList: true });
      try {
        const response = await CaptainPromptVersions.get({ assistantId });
        commit(mutations.SET, response.data.payload);
        commit(mutations.SET_UI_FLAG, { fetchingList: false });
      } catch (error) {
        commit(mutations.SET_UI_FLAG, { fetchingList: false });
        throwErrorMessage(error);
      }
    },

    restore: async ({ commit }, { id, assistantId }) => {
      commit(mutations.SET_UI_FLAG, { updatingItem: true });
      try {
        const response = await CaptainPromptVersions.restore({
          id,
          assistantId,
        });
        commit(mutations.SET_UI_FLAG, { updatingItem: false });
        return response.data;
      } catch (error) {
        commit(mutations.SET_UI_FLAG, { updatingItem: false });
        return throwErrorMessage(error);
      }
    },
  }),
});
